import { TruckSnowflakeIcon } from './TruckSnowflakeIcon';

/**
 * author: Erdem YILMAZ
 * id EEE6A113-50D3-4216-B103-C60D857D7E31
 * name truck-snowflake
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-snowflake.svg
 * tags
 * - Transportation + Road 
 */
export const TruckRefrigeratorIcon = TruckSnowflakeIcon;
export default TruckRefrigeratorIcon